/* ###########################################################################
// Throttle
//
// Caps how often `func` can run to once per `limit` ms, while still
// guaranteeing a trailing call so the final scroll/resize position is never
// dropped.
//######################################################################### */

export const throttle = (func, limit) => {
    let lastFunc
    let lastRan

    return function (...args) {
        if (!lastRan) {
            func.apply(this, args)
            lastRan = Date.now()

            return
        }

        clearTimeout(lastFunc)

        lastFunc = setTimeout(() => {
            if (Date.now() - lastRan >= limit) {
                func.apply(this, args)
                lastRan = Date.now()
            }
        }, limit - (Date.now() - lastRan))
    }
}
